import { render, staticRenderFns } from "./CustomerCustomFieldsData.vue?vue&type=template&id=28cc516e&scoped=true&lang=pug&"
import script from "./CustomerCustomFieldsData.vue?vue&type=script&lang=js&"
export * from "./CustomerCustomFieldsData.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCustomFieldsData.vue?vue&type=style&index=0&id=28cc516e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cc516e",
  null
  
)

/* custom blocks */
import block0 from "./CustomerCustomFieldsData.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports